// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "77b5f93",
    "hash": "77b5f93",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "77b5f93",
    "semverString": null,
    "version": "0.0.322"
};
/* tslint:enable */
